import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { NAMESPACES } from './namespaces';

// Import default translations for development and fallback
import commonEN from './languages/en/common.json';
import authEN from './languages/en/auth.json';
import dashboardEN from './languages/en/dashboard.json';
import usersEN from './languages/en/users.json';
import themeEN from './languages/en/theme.json';
import errorsEN from './languages/en/errors.json';
import welcomeEN from './languages/en/welcome.json';
import legalEN from './languages/en/legal.json';
import contentEN from './languages/en/content.json';

const resources = {
  en: {
    [NAMESPACES.COMMON]: commonEN,
    [NAMESPACES.AUTH]: authEN,
    [NAMESPACES.DASHBOARD]: dashboardEN,
    [NAMESPACES.USERS]: usersEN,
    [NAMESPACES.THEME]: themeEN,
    [NAMESPACES.ERRORS]: errorsEN,
    [NAMESPACES.WELCOME]: welcomeEN,
    [NAMESPACES.LEGAL]: legalEN,
    [NAMESPACES.CONTENT]: contentEN
  }
};

i18n
  // Load translations from server in production
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      // React already escapes values
      escapeValue: false,
    },
    
    // Preload these namespaces at startup for faster loading
    ns: [NAMESPACES.COMMON],
    defaultNS: NAMESPACES.COMMON,
    
    // Detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    // Backend options for loading translations from server
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n; 